import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 

import { AppRoutingModule } from './app-routing.module';
import { ProctorComponent } from './proctor/app-proctor.component';
import { LoadingdivComponent } from './loadingdiv/loadingdiv.component';
import { WebcamaccessnotificationdivComponent } from './webcamaccessnotificationdiv/webcamaccessnotificationdiv.component';
import { ExamiframeComponent } from './examiframe/examiframe.component';
import { ProcteevideomodalComponent } from './procteevideomodal/procteevideomodal.component';
import { ChatmodalComponent } from './chatmodal/chatmodal.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { SubdomainInterceptorInterceptor } from './interceptors/subdomain-interceptor.interceptor';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SecondViewIframeComponent } from './second-view-iframe/second-view-iframe.component';
import { SecondViewComponent } from './second-view/second-view.component';
import { AppComponent } from './app1.component';
import { InitiateSecondViewModalComponent } from './initiate-second-view-modal/initiate-second-view-modal.component';
import { FormsModule } from '@angular/forms';
import { LoadingSpinnerComponent } from './shared/loading-spinner/loading-spinner.component';
import { IndexComponent } from './index/index.component';
import { QRCodeModule } from 'angularx-qrcode';
import { AwaitProctorComponent } from './await-proctor/await-proctor.component';

@NgModule({
  declarations: [
    ProctorComponent,
    LoadingdivComponent,
    WebcamaccessnotificationdivComponent,
    ExamiframeComponent,
    ProcteevideomodalComponent,
    ChatmodalComponent,
    SecondViewIframeComponent,
    SecondViewComponent,
    AppComponent,
    InitiateSecondViewModalComponent,
    LoadingSpinnerComponent,
    IndexComponent,
    AwaitProctorComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      progressBar: true
    }),
    NgbModule,
    FormsModule,
    QRCodeModule
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: SubdomainInterceptorInterceptor,
    multi: true
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
